module.exports = __webpack_public_path__ + "static/media/chau_humedad.10911227.jpg";